import { useState, useEffect, useCallback } from 'react';
import * as auth from '../services/auth';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check local session first for faster initial load
    if (auth.isSessionValid()) {
      // Verify with server in background
      auth.verifySession().then(valid => {
        setIsAuthenticated(valid);
        setIsLoading(false);
      });
    } else {
      setIsAuthenticated(false);
      setIsLoading(false);
    }
  }, []);

  const login = useCallback(async (
    username: string, 
    password: string, 
    turnstileToken?: string
  ) => {
    const success = await auth.login(username, password, turnstileToken);
    setIsAuthenticated(success);
    return success;
  }, []);

  const logout = useCallback(async () => {
    await auth.logout();
    setIsAuthenticated(false);
  }, []);

  return { 
    isAuthenticated, 
    isLoading, 
    login, 
    logout, 
    getToken: auth.getToken 
  };
}
